import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";

const config = {
  apiKey: "AIzaSyDsaSjxPoSaDRaD8RqT9GSmTmSjaInerx0",
  authDomain: "lifewith-app-v1.firebaseapp.com",
  databaseURL: "https://lifewith-app-v1.firebaseio.com",
  projectId: "lifewith-app-v1",
  storageBucket: "lifewith-app-v1.appspot.com",
  messagingSenderId: "115707266039",
  appId: "1:115707266039:web:69098b4477678a0a6224f2",
  measurementId: "G-1ZZNX6P5LW"
};

firebase.initializeApp(config);

const auth = firebase.auth();
const db = firebase.firestore();
const storage = firebase.storage();

export default {
  auth,
  db,
  storage
};
